import popup from './popup.js'

let watchId = null

// Locationを取得する
export const getCurLocation = (options) => {
  return new Promise((resolve, reject) => {
    const result = {}
    // if (!options || !options.timeout) {
    //   options.timeout = 5000
    // }
    if (navigator.geolocation) {
      // if (location.protocol !== 'http:') {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          result.latitude = position.coords.latitude
          result.longitude = position.coords.longitude
          result.accuracy = position.coords.accuracy
          result.altitude = position.coords.altitude
          result.altitudeAccuracy = position.coords.altitudeAccuracy
          result.heading = position.coords.heading
          result.speed = position.coords.speed
          result.timestamp = position.timestamp
          return resolve(result)
        },
        (e) => {
          result.latitude = '0.0'
          result.longitude = '0.0'
          result.timestamp = new Date().getTime()
          return reject(result)
        },
        options
      )
      // } else {
      //   result.latitude = '35.4516992'
      //   result.longitude = '139.6342784'
      //   result.timestamp = new Date().getTime()
      //   return resolve(result)
      // }
    } else {
      popup({
        text: 'この端末では、位置情報が取得できません。',
      })
      return reject(result)
    }
  })
}

export const watchPosition = (options) => {
  if (watchId) {
    navigator.geolocation.clearWatch(watchId)
    watchId = null
  }

  const timeout = options && options.timeout ? options.timeout : 16000

  return new Promise((resolve, reject) => {
    const result = {}

    if (process.env.VUE_APP_MODE == 'development') {
      result.latitude = 35.4615296
      result.longitude = 139.63755519999998
      result.timestamp = new Date().getTime()
      return resolve(result)
    }

    if (navigator.geolocation) {
      var startApiTime = new Date().getTime()
      if (window.geoTimer) {
        clearInterval(window.geoTimer)
        window.geoTimer = null
      }
      window.geoTimer = setInterval(() => {
        if (new Date().getTime() - startApiTime >= timeout) {
          navigator.geolocation.clearWatch(watchId)
          watchId = null
          result.latitude = '0.0'
          result.longitude = '0.0'
          result.timestamp = new Date().getTime()
          clearInterval(window.geoTimer)
          window.geoTimer = null
          return reject({ result: result, code: 3 })
        }
      }, 1000)
      watchId = navigator.geolocation.watchPosition(
        (position) => {
          navigator.geolocation.clearWatch(watchId)
          watchId = null
          result.latitude = position.coords.latitude
          result.longitude = position.coords.longitude
          result.timestamp = new Date().getTime()
          clearInterval(window.geoTimer)
          window.geoTimer = null
          return resolve(result)
        },
        (e) => {
          console.log(e)
          navigator.geolocation.clearWatch(watchId)
          watchId = null
          result.latitude = '0.0'
          result.longitude = '0.0'
          result.timestamp = new Date().getTime()
          clearInterval(window.geoTimer)
          window.geoTimer = null
          return reject({ result: result, code: e.code })
        },
        {
          timeout: 15000,
          maximumAge: 0,
        }
      )
    } else {
      popup({
        text: 'この端末では、位置情報が取得できません。',
      })
      return reject({ result: result, code: 1 })
    }
  })
}
